/**
 * Papier Royal — Initiales marquées à chaud, en natif (sans Customily).
 *
 * TROIS BRIQUES, aucune modification des fichiers Horizon coeur :
 *
 *  1. SAISIE + VALIDATION — champ initiales (A-Z, 5 max, forcé en majuscules) et grille
 *     3×3 des 9 positions, reprises à l'identique de l'option set Customily des carnets
 *     Royal. La personnalisation est FACULTATIVE : champ vide = aucun blocage, aucune
 *     propriété, aucune ligne add-on.
 *
 *  2. ATC ATOMIQUE — dès que le champ est rempli, on préempte le submit du form et on
 *     poste les DEUX lignes en UN SEUL /cart/add.js {items:[…]} :
 *        add-on (quantity = nb_lettres × nb_carnets) puis carnet (quantity = nb_carnets).
 *     ORDRE VOULU : Shopify affiche le panier en ordre INVERSE de l'ajout, donc le carnet
 *     ajouté EN DERNIER remonte en tête du groupe (même leçon que pr-carnet-cart.js).
 *     Champ vide → on ne touche à RIEN, le form part en natif comme aujourd'hui, avec le
 *     Fil. Zéro régression sur le chemin existant.
 *
 *  3. SUPPRESSION ATOMIQUE DU GROUPE — clic sur la poubelle d'une ligne carnet portant
 *     `_pr-init-id` → les deux lignes partent ensemble, en un seul /cart/update.js.
 *     Écoute sur WINDOW en capture : Customily écoute en capture sur DOCUMENT (son
 *     intercepteur anti-orphelin), window-capture s'exécute avant, on gagne la course.
 *     Cf. le même contournement dans pr-carnet-cart.js.
 *
 *  + APERÇU LIVE : calque posé au-dessus de la photo de COUVERTURE affichée, et d'elle
 *    seule. On lit la diapositive active du carrousel (`aria-hidden="false"`), on vérifie
 *    que sa photo fait partie des couvertures (image de variante, une par teinte), on
 *    calcule son rectangle utile en tenant compte du letterboxing d'object-fit, et on pose
 *    un calque absolu dans document.body. Sur une double page ou un détail de reliure, rien
 *    ne s'affiche. Repositionnement sur scroll/resize/mutation, throttlé en rAF avec relais
 *    setTimeout. Quand la couverture sort de l'écran, une vignette-loupe prend le relais.
 *
 * REPORTING ATELIER (online only) — les valeurs canoniques EN partent dans les propriétés
 * masquées `_initiales_ref` et `_position_ref`, stables quelle que soit la langue du client :
 *   orders(query:"channel:'online store'"){ nodes{ lineItems{ nodes{
 *     quantity customAttributes{ key value } } } } }
 *   → key=="_initiales_ref" pour le texte, key=="_position_ref" pour l'emplacement.
 */
(function () {
  'use strict';

  var CID_PROP = '_pr-init-id';
  var ROLE_PROP = '_pr-init-role';
  var LETTERS = /[^A-Za-z]/g;

  // MÉTRIQUES DE LA FONTE DE MARQUAGE (KIRCH Regular, upm 1000, capHeight 700,
  // hhea ascender 1000 / descender -200). Elles servent à positionner l'ENCRE et non la
  // boîte de texte : avec line-height:1 le haut de capitale tombe 0.20 em sous le haut de
  // la boîte, et les capitales font 0.70 em de haut. Sans cette correction, un marquage
  // calé « à 3 % du bord haut » se retrouve visiblement trop bas.
  // Changer de fonte = recalculer ces deux nombres, rien d'autre.
  var CAP_RATIO = 0.70;   // hauteur de capitale, en em
  var INK_TOP_EM = 0.20;  // haut de capitale sous le haut de la boîte, en em

  // Vignette collante : sur TOUS les écrans, et seulement quand la photo de couverture est
  // sortie de l'écran. Au-dessus de ce seuil de visibilité, la vraie photo suffit.
  // (Elle était limitée au mobile ; sur desktop la galerie finit aussi par défiler hors champ
  // et l'aperçu disparaissait au moment où le client tape ses initiales.)
  var STICKY_SHOW_UNDER = 0.18;
  // Le marquage réel ne fait que ~3 % de la hauteur de couverture : sur une vignette de la
  // couverture entière, les initiales tombaient à 2,5 px, donc illisibles — l'inverse du but
  // recherché. La vignette est donc une LOUPE : on affiche la couverture agrandie, cadrée sur
  // l'emplacement choisi, à une échelle calculée pour que la capitale fasse cette taille.
  // Le « où sur la couverture » reste porté par la grille 3×3 du sélecteur, qui est un plan
  // de la couverture ; la vignette porte le « quelles lettres, sur quelle matière ».
  var STICKY_TARGET_CAP = 11; // px

  function log() {
    if (window.PR_INIT_DEBUG && window.console) console.log.apply(console, ['[pr-init]'].concat([].slice.call(arguments)));
  }

  // Racine localisée : sur une page /fr/…, taper /cart/add.js au lieu de /fr/cart/add.js
  // renvoie sur la mauvaise route. Shopify.routes.root finit toujours par '/'.
  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function genUuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'ini-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function getMorphableSections() {
    var sections = new Set();
    document.querySelectorAll('[data-section-id], [id^="shopify-section-"]').forEach(function (el) {
      var id = el.dataset.sectionId || el.id.replace('shopify-section-', '');
      if (id && (el.querySelector('cart-drawer-component') || el.querySelector('cart-items-component') || id.indexOf('header') !== -1)) {
        sections.add(id);
      }
    });
    return Array.from(sections).join(',');
  }

  function dispatchCartUpdate(data, source) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: data,
        sourceId: source || 'pr-init',
        data: { sections: data && data.sections, source: source || 'pr-init', itemCount: data && data.item_count }
      }
    }));
  }

  function formatMoney(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{{') !== -1) {
      // On ne réimplémente pas le moteur de Shopify : on remplace le premier placeholder,
      // ce qui couvre amount / amount_with_comma_separator sur ce store (EUR).
      if (fmt.indexOf('comma_separator') !== -1 || fmt.indexOf('comma') !== -1) v = v.replace('.', ',');
      return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, v);
    }
    return v.replace('.', ',') + ' €';
  }

  // ──────── APERÇU ────────
  // Rectangle RÉELLEMENT occupé par les pixels de l'image dans son élément, une fois
  // le letterboxing d'object-fit:contain retiré. Sans ça, le calage part de travers
  // dès que le ratio du conteneur diffère du ratio de la photo.
  function containedRect(img) {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    if (!nw || !nh || !r.width || !r.height) return null;
    var fit = getComputedStyle(img).objectFit;
    if (fit !== 'contain' && fit !== 'scale-down') {
      return { x: r.left, y: r.top, w: r.width, h: r.height };
    }
    var scale = Math.min(r.width / nw, r.height / nh);
    if (fit === 'scale-down') scale = Math.min(scale, 1);
    var w = nw * scale;
    var h = nh * scale;
    return { x: r.left + (r.width - w) / 2, y: r.top + (r.height - h) / 2, w: w, h: h };
  }

  // Photo de COUVERTURE actuellement affichée dans la galerie, ou null.
  //
  // Deux pièges, découverts en test le 2026-08-28 :
  //
  //  1. Le carrousel d'Atelier garde TOUTES les diapositives dans le DOM, alignées côte à côte
  //     dans un conteneur qui défile horizontalement. Une photo non affichée a donc un
  //     rectangle parfaitement valide, juste hors écran. Chercher « la plus grande image
  //     visible » ne suffit pas : il faut lire la diapositive marquée `aria-hidden="false"`,
  //     seul signal fiable de celle qui est réellement à l'écran.
  //
  //  2. La galerie met en tête l'image de la VARIANTE sélectionnée, pas l'image mise en avant
  //     du produit. Le filtre ne peut donc pas viser un seul fichier : il vise la liste des
  //     photos de couverture, c'est-à-dire l'image de chaque variante (une par teinte de
  //     couverture) plus l'image mise en avant. Toute autre photo — double page, détail de
  //     reliure — renvoie null, et rien ne s'affiche : le calage n'y a aucun sens.
  function activeCoverImage(coverFiles) {
    var active = null;
    document.querySelectorAll('slideshow-slide.product-media-container, .product-media-container').forEach(function (s) {
      if (!active && s.getAttribute('aria-hidden') === 'false') active = s;
    });
    if (!active) return null;
    var img = active.querySelector('img');
    if (!img || !img.complete || !img.naturalWidth) return null;
    if (!coverFiles || !coverFiles.length) return img;
    var src = img.currentSrc || img.src || '';
    for (var i = 0; i < coverFiles.length; i++) {
      if (coverFiles[i] && src.indexOf(coverFiles[i]) !== -1) return img;
    }
    return null;
  }

  // Géométrie du marquage, en FRACTIONS de la boîte image (0 à 1), sans unité.
  // La boîte « couverture » est exprimée en % de l'image ; les 9 positions se déduisent de
  // cette boîte, du retrait `pad` et de la hauteur de capitale `cap`. Un seul jeu de valeurs à
  // régler par produit, au lieu de neuf jeux de coordonnées.
  //
  // Des fractions plutôt que des pixels, parce que le même calcul sert à deux rendus qui ne
  // doivent jamais diverger : le calque posé DANS la diapositive, exprimé en % et en cqh donc
  // recalculé par le navigateur, et la vignette-loupe, exprimée en pixels.
  function geometry(zones, code) {
    var b = zones.box;
    var pad = typeof zones.pad === 'number' ? zones.pad : 3;
    var cap = typeof zones.cap === 'number' ? zones.cap : 2.96;

    var bx = b.x / 100, by = b.y / 100, bw = b.w / 100, bh = b.h / 100;
    var padX = (bw * pad) / 100, padY = (bh * pad) / 100;

    // `cap` décrit la hauteur de CAPITALE voulue, pas le corps : c'est la grandeur qu'on
    // mesure sur un marquage réel. Le corps s'en déduit par les métriques de la fonte.
    var fs = (bh * cap) / 100 / CAP_RATIO; // corps, en fraction de la HAUTEUR de la boîte
    var inkH = CAP_RATIO * fs;             // hauteur d'encre (capitales seules, pas de jambage)
    var inkOffset = INK_TOP_EM * fs;       // du haut de la boîte de texte au haut de capitale

    var row = code[0], col = code[1];
    var left, tx, inkY;
    if (col === 'l') { left = bx + padX; tx = '0'; }
    else if (col === 'r') { left = bx + bw - padX; tx = '-100%'; }
    else { left = bx + bw / 2; tx = '-50%'; }

    // On vise l'ENCRE : haut de capitale pour la rangée haute, bas de capitale pour la rangée
    // basse, milieu d'encre pour la rangée médiane. La boîte de texte est ensuite remontée de
    // `inkOffset` pour que l'encre tombe pile là.
    if (row === 't') inkY = by + padY;
    else if (row === 'b') inkY = by + bh - padY - inkH;
    else inkY = by + bh / 2 - inkH / 2;

    return { left: left, top: inkY - inkOffset, fs: fs, tx: tx };
  }

  // Hauteur occupée en bas de l'écran par une barre fixe du thème (barre d'ajout au panier
  // collante sur mobile). Mesurée à chaud plutôt que codée en dur : le thème peut la changer.
  function bottomBarHeight() {
    var h = 0;
    document.querySelectorAll('sticky-add-to-cart-component, [class*="sticky-add-to-cart"], [class*="sticky-buy"]').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height && r.bottom > window.innerHeight - 4) h = Math.max(h, r.height);
    });
    return h;
  }

  function initPicker(root) {
    if (root.__prInit) return;
    root.__prInit = true;

    var formId = root.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) form = root.closest('form') || (root.closest('product-form-component') || document).querySelector('form');
    if (!form) return;

    var input = root.querySelector('[data-pr-init-input]');
    var countEl = root.querySelector('[data-pr-init-count]');
    var sumEl = root.querySelector('[data-pr-init-sum]');
    var posWrap = root.querySelector('[data-pr-init-positions]');
    var posLabelEl = root.querySelector('[data-pr-init-poslabel]');
    var errorEl = root.querySelector('[data-pr-init-error]');
    var cells = Array.prototype.slice.call(root.querySelectorAll('[data-pr-init-pos]'));
    if (!input) return;

    var addonVariant = Number(root.getAttribute('data-addon-variant'));
    var addonPrice = Number(root.getAttribute('data-addon-price')) || 0;
    var maxChars = Number(root.getAttribute('data-max')) || 5;
    var moneyFormat = root.getAttribute('data-money-format') || '';
    var keyInitiales = root.getAttribute('data-key-initiales') || 'Initiales';
    var keyPosition = root.getAttribute('data-key-position') || 'Position';
    var coverFiles = (root.getAttribute('data-cover-files') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var zones;
    try { zones = JSON.parse(root.getAttribute('data-zones')); } catch (e) { zones = null; }
    // `cap` et `pad` sont relevés au pixel sur les rendus Customily du carnet Royal A4 :
    // capitale = 2,96 % de la hauteur de couverture, marge de bord = 3 %.
    if (!zones || !zones.box) zones = { box: { x: 10, y: 8, w: 80, h: 84 }, cap: 2.96, pad: 3 };

    function value() { return (input.value || '').replace(LETTERS, '').toUpperCase().slice(0, maxChars); }
    function current() {
      var c = cells.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || cells[0];
      return c;
    }

    // ──────── Calque d'aperçu ────────
    // Le marquage est posé DANS la diapositive, pas dans document.body.
    //
    // La première version plaçait un calque absolu dans le body et le repositionnait en JS à
    // chaque frame de défilement, d'après getBoundingClientRect(). Le navigateur peignait la
    // photo à sa nouvelle place, le calque ne rattrapait qu'à la frame suivante : le texte
    // flottait visiblement au-dessus de la couverture au lieu d'y être imprimé. Aucun
    // étranglement ni aucune optimisation ne corrige ça, c'est la conception qui était fausse.
    //
    // Désormais le texte est un enfant du conteneur de la photo, positionné en POURCENTAGES,
    // avec un corps en `cqh` (unité de requête de conteneur). Le navigateur le déplace donc
    // avec la photo, sur le compositeur, sans une ligne de JS pendant le défilement. Il ne
    // peut plus décrocher, y compris sur galerie collante, changement de diapositive ou zoom.
    // Le JS n'intervient plus qu'aux changements d'état : saisie, position, variante,
    // diapositive, redimensionnement.
    function inkLayerFor(img) {
      var host = img.parentNode;
      if (!host) return null;
      var ink = host.querySelector(':scope > .pr-init-ink');
      if (!ink) {
        ink = document.createElement('div');
        ink.className = 'pr-init-ink';
        var t = document.createElement('span');
        t.className = 'pr-init-overlay__txt';
        ink.appendChild(t);
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        host.appendChild(ink);
      }
      return ink;
    }

    function clearInkLayers(keep) {
      document.querySelectorAll('.pr-init-ink').forEach(function (n) {
        if (n !== keep) n.remove();
      });
    }

    // ──────── VIGNETTE COLLANTE MOBILE ────────
    // Sur mobile la photo de couverture est en haut de page : dès qu'on descend jusqu'au
    // champ des initiales, on ne la voit plus, et on tape à l'aveugle. Une vignette fixe
    // reprend alors la couverture et le marquage, avec EXACTEMENT le même calcul de
    // placement (fonction `paint` partagée), pour qu'elle ne puisse pas mentir sur le rendu.
    var stickyWrap = null, stickyPane = null, stickyImg = null, stickyTxt = null;
    var coverSrc = root.getAttribute('data-cover-src') || '';
    function buildSticky() {
      if (stickyWrap || !coverSrc) return;
      stickyWrap = document.createElement('div');
      stickyWrap.className = 'pr-init-sticky';
      stickyWrap.hidden = true;
      stickyPane = document.createElement('div');
      stickyPane.className = 'pr-init-sticky__pane';
      stickyImg = document.createElement('img');
      stickyImg.className = 'pr-init-sticky__img';
      stickyImg.alt = '';
      stickyImg.decoding = 'async';
      stickyImg.src = coverSrc;
      stickyTxt = document.createElement('span');
      stickyTxt.className = 'pr-init-overlay__txt';
      stickyPane.appendChild(stickyImg);
      stickyPane.appendChild(stickyTxt);
      stickyWrap.appendChild(stickyPane);
      document.body.appendChild(stickyWrap);
      stickyImg.addEventListener('load', updateSticky);
    }

    // Fraction de l'image de couverture réellement visible à l'écran, entre 0 et 1.
    function visibleFraction(img) {
      if (!img) return 0;
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return 0;
      var vw = window.innerWidth || 0, vh = window.innerHeight || 0;
      var w = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
      var h = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      return (w * h) / (r.width * r.height);
    }

    function placeSticky(v, cell, stageImg) {
      var wanted = !!v && !!stageImg && visibleFraction(stageImg) < STICKY_SHOW_UNDER;
      if (!wanted) {
        if (stickyWrap) { stickyWrap.hidden = true; stickyOn = false; }
        return;
      }
      buildSticky();
      if (!stickyWrap) return;
      // La vignette suit la teinte de couverture choisie : on reprend la source de la photo
      // réellement affichée plutôt qu'une image figée, sinon un client qui choisit « Bleu
      // foncé » verrait son marquage sur la couverture rouge.
      var live = (stageImg.currentSrc || stageImg.src || '').split('&width=')[0];
      if (live && stickyImg.getAttribute('data-live') !== live) {
        stickyImg.setAttribute('data-live', live);
        stickyImg.src = live + '&width=700';
      }
      if (!stickyImg.complete || !stickyImg.naturalWidth) return;
      stickyWrap.style.bottom = (bottomBarHeight() + 12) + 'px';
      stickyWrap.hidden = false;

      // Échelle de la loupe : taille à laquelle il faut rendre la couverture pour que la
      // capitale atteigne STICKY_TARGET_CAP pixels. Découle directement du calage du produit.
      var b = zones.box;
      var capPct = typeof zones.cap === 'number' ? zones.cap : 2.96;
      var side = STICKY_TARGET_CAP / ((b.h / 100) * (capPct / 100));
      // `side` est la taille à laquelle rendre la couverture pour que la capitale atteigne
      // STICKY_TARGET_CAP pixels. geometry() renvoyant des fractions, la conversion est directe.
      stickyPane.style.width = side.toFixed(1) + 'px';
      stickyPane.style.height = side.toFixed(1) + 'px';
      var gs = geometry(zones, cell.getAttribute('data-cell') || 'bc');
      stickyTxt.textContent = v;
      stickyTxt.style.left = (gs.left * side).toFixed(2) + 'px';
      stickyTxt.style.top = (gs.top * side).toFixed(2) + 'px';
      stickyTxt.style.transform = 'translateX(' + gs.tx + ')';
      stickyTxt.style.fontSize = (gs.fs * side).toFixed(2) + 'px';

      // Recadrage : on amène le centre de l'encre au centre de la fenêtre, puis on borne le
      // déplacement pour ne jamais laisser apparaître de vide autour de la couverture.
      var win = stickyWrap.getBoundingClientRect();
      var ink = stickyTxt.getBoundingClientRect();
      var pane = stickyPane.getBoundingClientRect();
      var cx = ink.left - pane.left + ink.width / 2;
      var cy = ink.top - pane.top + ink.height / 2;
      var dx = win.width / 2 - cx;
      var dy = win.height / 2 - cy;
      dx = Math.min(0, Math.max(win.width - side, dx));
      dy = Math.min(0, Math.max(win.height - side, dy));
      stickyPane.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
    }

    var lastCoverImg = null;

    function layoutInk() {
      var v = value();
      var cell = current();
      if (!v || !cell) { clearInkLayers(null); lastCoverImg = null; if (stickyWrap) stickyWrap.hidden = true; return; }

      var img = activeCoverImage(coverFiles);
      // Diapositive active qui n'est pas une couverture (double page, détail de reliure) :
      // ni calque ni vignette. Le marquage ne se montre que sur la couverture.
      if (!img) { clearInkLayers(null); lastCoverImg = null; placeSticky('', cell, null); return; }

      var host = img.parentNode;
      var hr = host.getBoundingClientRect();
      var rect = containedRect(img);
      if (!rect || !hr.width || !hr.height) { clearInkLayers(null); placeSticky('', cell, null); return; }

      var ink = inkLayerFor(img);
      if (!ink) return;
      clearInkLayers(ink);
      lastCoverImg = img;

      // Le calque épouse le rectangle RÉELLEMENT occupé par les pixels de la photo, une fois
      // le letterboxing d'object-fit retiré, exprimé en % de son conteneur. Ces pourcentages
      // ne dépendent que de la mise en page, jamais du défilement.
      ink.style.left = (((rect.x - hr.left) / hr.width) * 100).toFixed(4) + '%';
      ink.style.top = (((rect.y - hr.top) / hr.height) * 100).toFixed(4) + '%';
      ink.style.width = ((rect.w / hr.width) * 100).toFixed(4) + '%';
      ink.style.height = ((rect.h / hr.height) * 100).toFixed(4) + '%';

      var g = geometry(zones, cell.getAttribute('data-cell') || 'bc');
      var t = ink.firstChild;
      t.textContent = v;
      t.style.left = (g.left * 100).toFixed(4) + '%';
      t.style.top = (g.top * 100).toFixed(4) + '%';
      t.style.transform = 'translateX(' + g.tx + ')';
      // 1cqh vaut 1 % de la HAUTEUR du calque : le corps suit donc la photo à toute taille,
      // sans que le JS ait à recalculer quoi que ce soit au redimensionnement.
      t.style.fontSize = (g.fs * 100).toFixed(4) + 'cqh';
      ink.classList.add('is-on');

      updateSticky();
    }

    // La vignette-loupe, elle, dépend du défilement : c'est sa VISIBILITÉ qui change, pas sa
    // position, puisqu'elle est en position fixe. Une frame de retard sur un afficher/masquer
    // ne se voit pas, contrairement à un décrochage de calque.
    function updateSticky() {
      var v = value();
      var cell = current();
      if (!v || !cell || !lastCoverImg) { if (stickyWrap) stickyWrap.hidden = true; return; }
      placeSticky(v, cell, lastCoverImg);
    }

    var raf = 0, tmo = 0;
    function queuePlace() {
      cancelAnimationFrame(raf);
      clearTimeout(tmo);
      raf = requestAnimationFrame(layoutInk);
      // Filet : requestAnimationFrame est SUSPENDU quand la page n'est pas peinte (onglet en
      // arrière-plan, fenêtre masquée). Sans ce relais, le calque restait figé sur son dernier
      // état au retour. layoutInk est idempotent, le doublon est sans effet.
      tmo = setTimeout(layoutInk, 120);
    }

    // LE DÉFILEMENT NE RECALCULE PLUS RIEN DU CALQUE. Il ne sert qu'à décider si la
    // vignette-loupe doit apparaître, ce qui n'a aucune incidence sur le calage du marquage.
    var srafr = 0;
    window.addEventListener('scroll', function () {
      cancelAnimationFrame(srafr);
      srafr = requestAnimationFrame(updateSticky);
    }, { passive: true });

    window.addEventListener('resize', queuePlace, { passive: true });
    document.addEventListener('shopify:section:load', queuePlace);
    // activeCoverImage() exige une image DÉCODÉE (complete + naturalWidth). Au premier rendu,
    // la galerie n'a souvent encore rien chargé : sans ces deux filets, le calque restait
    // invisible jusqu'au premier scroll de l'utilisateur. Les <img> ne font pas bouillonner
    // leur évènement `load`, d'où l'écoute en CAPTURE sur document.
    document.addEventListener('load', queuePlace, true);
    window.addEventListener('load', queuePlace);
    [200, 600, 1200, 2500].forEach(function (ms) { setTimeout(queuePlace, ms); });
    if (window.ResizeObserver) {
      // On observe la GALERIE et non le document : c'est sa taille qui détermine le calage,
      // et l'observer évite de tout recalculer au moindre changement de hauteur de page.
      var ro = new ResizeObserver(queuePlace);
      ro.observe(document.documentElement);
      var galleryRoot = document.querySelector('media-gallery, media-gallery-component, [id^="MediaGallery"], .media-gallery');
      if (galleryRoot) ro.observe(galleryRoot);
    }
    // La galerie change d'image au choix de variante ET au défilement du carrousel : on suit
    // les mutations du DOM produit plutôt que d'écouter un évènement propre au thème.
    //
    // Deux corrections issues du test du 2026-08-28 :
    //  - observer la RACINE de la galerie, et non `.product-media-container` qui désigne une
    //    diapositive isolée : on ne voyait alors que les mutations de la première.
    //  - surveiller `aria-hidden`, l'attribut par lequel le carrousel désigne la diapositive
    //    active. Sans lui, passer à la double page ne relançait aucun calcul et le marquage
    //    restait affiché par-dessus.
    var stage = document.querySelector('media-gallery, media-gallery-component, [id^="MediaGallery"], .media-gallery, .product-information__media');
    if (stage && window.MutationObserver) {
      new MutationObserver(queuePlace).observe(stage, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['src', 'class', 'style', 'hidden', 'aria-hidden']
      });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queuePlace);

    // ──────── Saisie ────────
    function refresh() {
      var raw = input.value || '';
      var clean = raw.replace(LETTERS, '').toUpperCase().slice(0, maxChars);
      if (clean !== raw) {
        var bad = /[^A-Za-z]/.test(raw);
        input.value = clean;
        if (bad && errorEl) errorEl.classList.remove('hidden');
      } else if (errorEl) {
        errorEl.classList.add('hidden');
      }
      var n = clean.length;
      if (countEl) countEl.textContent = n + '/' + maxChars;
      if (sumEl) {
        if (n > 0) { sumEl.hidden = false; sumEl.textContent = '+ ' + formatMoney(addonPrice * n, moneyFormat); }
        else { sumEl.hidden = true; }
      }
      if (posWrap) posWrap.hidden = n === 0;

      // PAIEMENT ACCÉLÉRÉ. Shop Pay et PayPal ne passent PAS par la soumission du formulaire :
      // ni les initiales ni la ligne de dorure ne partiraient avec la commande, et le client
      // recevrait un carnet nu en croyant l'avoir fait marquer — sans même avoir été facturé
      // du marquage, donc sans réclamation possible avant réception. Tant que des initiales
      // sont saisies, ces boutons sont retirés : le parcours passe alors par « Ajouter au
      // panier », qui lui est intercepté. Ils réapparaissent dès que le champ est vidé.
      document
        .querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .accelerated-checkout, [class*="accelerated-checkout"]')
        .forEach(function (b) { b.classList.toggle('pr-init-accel-off', n > 0); });
      var cell = current();
      if (posLabelEl && cell) posLabelEl.textContent = n > 0 ? cell.getAttribute('data-label') : '';
      queuePlace();
    }

    input.addEventListener('input', refresh);
    input.addEventListener('blur', refresh);

    cells.forEach(function (cell) {
      cell.addEventListener('click', function (e) {
        e.preventDefault();
        cells.forEach(function (c) { c.setAttribute('aria-checked', c === cell ? 'true' : 'false'); });
        refresh();
      });
    });

    refresh();

    // ──────── ATC atomique ────────
    function coverVariantId() {
      var el = form.querySelector('input[name="id"], select[name="id"]');
      return el ? Number(el.value) : 0;
    }
    function coverQty() {
      var el = form.querySelector('input[name="quantity"], select[name="quantity"]');
      var q = el ? Number(el.value) : 1;
      return q > 0 ? q : 1;
    }
    // Le Fil est posé par pr-fil-picker.liquid dans le MÊME form : on le relit ici pour
    // le reporter dans le payload JSON, puisqu'on court-circuite la soumission native.
    function filProps() {
      var out = {};
      var sel = document.querySelector('[data-pr-fil-select]');
      var ref = document.querySelector('[data-pr-fil-ref]');
      if (sel && sel.value) out['Fil'] = sel.value;
      if (ref && ref.value) out['_fil_ref'] = ref.value;
      return out;
    }

    async function addBoth() {
      var v = value();
      var cell = current();
      var qty = coverQty();
      var coverId = coverVariantId();
      if (!v || !cell || !coverId || !addonVariant) throw new Error('[pr-init] payload incomplet');

      var uuid = genUuid();
      var addonProps = {};
      addonProps[CID_PROP] = uuid;
      addonProps[ROLE_PROP] = 'service';
      addonProps[keyInitiales] = v;

      var coverProps = filProps();
      coverProps[keyInitiales] = v;
      coverProps[keyPosition] = cell.getAttribute('data-label');
      coverProps['_initiales_ref'] = v;
      coverProps['_position_ref'] = cell.getAttribute('data-en');
      coverProps[CID_PROP] = uuid;
      coverProps[ROLE_PROP] = 'couverture';

      // add-on D'ABORD, carnet EN DERNIER → le carnet remonte en tête du groupe.
      var items = [
        { id: addonVariant, quantity: v.length * qty, properties: addonProps },
        { id: coverId, quantity: qty, properties: coverProps }
      ];
      log('add', uuid, items);

      var res = await fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: getMorphableSections(), sections_url: window.location.pathname })
      });
      if (!res.ok) {
        var t = '';
        try { t = await res.text(); } catch (e) {}
        throw new Error('[pr-init] /cart/add.js a échoué (' + res.status + ') ' + t);
      }
      var data = await res.json();
      dispatchCartUpdate(data, 'pr-init-add');
      return data;
    }

    // Verrou d'envoi : quel que soit le chemin qui déclenche l'ajout (clic, submit),
    // on ne poste jamais deux fois le même groupe.
    var busy = false;
    function runAdd() {
      if (busy) return;
      busy = true;
      var btns = form.querySelectorAll('.add-to-cart-button, button[name="add"], [ref="addToCartButton"]');
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      addBoth()
        .catch(function (err) {
          if (window.console) console.error(err);
          if (errorEl) { errorEl.textContent = String(err.message || err); errorEl.classList.remove('hidden'); }
        })
        .finally(function () {
          busy = false;
          btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
        });
    }

    // POINT D'ACCROCHE : le CLIC, en capture sur WINDOW.
    // Intercepter `submit` sur le form NE SUFFIT PAS. Le product-form-component d'Atelier
    // écoute lui aussi en capture, mais sur un ANCÊTRE : la phase de capture descendant du
    // haut vers la cible, son handler s'exécute AVANT le nôtre et a déjà lancé son
    // /cart/add.js natif quand on veut l'arrêter. Symptôme observé le 2026-08-28 : une
    // TROISIÈME ligne « carnet nu » ajoutée à côté du groupe couverture + add-on.
    // window-capture est le seul point qui passe avant tout le monde — même contournement
    // que pr-carnet-cart.js pour la poubelle du panier.
    window.addEventListener('click', function (e) {
      if (!value()) return; // pas d'initiales → chemin natif intact (Fil compris)
      var btn = e.target && e.target.closest
        ? e.target.closest('.add-to-cart-button, button[name="add"], [ref="addToCartButton"]')
        : null;
      if (!btn) return;
      if (btn.form !== form && !form.contains(btn)) return; // un autre produit de la page
      e.preventDefault();
      e.stopImmediatePropagation();
      runAdd();
    }, true);

    // Filet : un submit déclenché autrement qu'au clic (touche Entrée, appel programmatique).
    // Le verrou `busy` garantit qu'il ne double pas le chemin ci-dessus.
    form.addEventListener('submit', function (e) {
      if (!value()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      runAdd();
    }, true);
  }

  // ──────── Suppression atomique du groupe ────────
  async function removeGroup(groupId) {
    async function attempt() {
      var cart = await fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      var updates = {};
      var n = 0;
      cart.items.forEach(function (it) {
        var props = it.properties || {};
        if (props[CID_PROP] === groupId) { updates[it.key] = 0; n++; }
      });
      log('removeGroup: lignes trouvées =', n);
      if (n === 0) return { done: true, data: cart };
      var res = await fetch(cartUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: getMorphableSections(), sections_url: window.location.pathname })
      });
      return { done: res.ok, status: res.status, res: res };
    }
    try {
      var r = await attempt();
      if (r.status === 422) r = await attempt(); // relance unique
      if (r.done) {
        var data = r.data || (r.res ? await r.res.json() : null);
        dispatchCartUpdate(data || { sections: null }, 'pr-init-remove');
        return;
      }
      throw new Error('update.js status ' + r.status);
    } catch (e) {
      log('removeGroup fail-open', e);
      window.location.reload(); // on ne laisse jamais l'utilisateur coincé
    }
  }

  // WINDOW capture : s'exécute avant l'intercepteur document-capture de Customily
  // ET avant le on:click d'Horizon. Uniquement sur les lignes marquées init.
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cart-items__remove') : null;
    if (!btn) return;
    var row = btn.closest('[data-group-source="init"]');
    if (!row) return;
    var gid = row.getAttribute('data-carnet-id');
    if (!gid) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    removeGroup(gid);
  }, true);

  function initAll(root) {
    (root || document).querySelectorAll('pr-initiales').forEach(initPicker);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.PRInitiales = { removeGroup: removeGroup };
})();
